
import { useParams } from 'react-router-dom';
import { ColoresFormState } from '../../../context/colores/ColoresFormState';
import { Form } from './form';

export const ColoresFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Color" : "Crear Color";

  return (
    <ColoresFormState>
        <br />
        <Form title={title} />
    </ColoresFormState>
  );
};
